import VerifyEmail from '@/components/Auth/VerifyEmail'

const VerifyEmailScreen = () => {
  return <VerifyEmail />
}

export default VerifyEmailScreen
